import React from 'react'

import Svg, { Path } from 'react-native-svg'

const EditIcon = ({ size = 20, color = '#1C1D1F', ...props }) => (
  <Svg width={size} height={size} viewBox="0 0 11 11" fill="none" {...props}>
    <Path
      d="M5.69992 2.37335L0.706584 7.61335C0.59325 7.73335 0.526584 7.88002 0.506584 8.04669L0.29325 9.99335C0.25325 10.36 0.59325 10.68 0.959917 10.6134L2.97325 10.24C3.13325 10.2134 3.27325 10.1334 3.38658 10.02L8.29325 4.87335L5.69992 2.37335Z"
      fill={color}
    />
    <Path
      d="M9.88005 1.88668L8.58005 0.653348C8.22005 0.306682 7.68005 0.286682 7.38005 0.600015L6.38672 1.64002L8.98005 4.14002L9.98672 3.08001C10.2867 2.76668 10.2334 2.22668 9.87339 1.88668H9.88005Z"
      fill={color}
    />
  </Svg>
)
export default EditIcon
